import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SaveCancelButtonConfig } from '@app/infrastructure/models/form/button';
import { Critter } from '@app/infrastructure/models/critter';

@Component({
  templateUrl: './critter-dialog.component.html',
  styleUrls: ['./critter-dialog.component.scss'],
})
export class CritterDialogComponent implements OnInit {
  critterImage: string;

  buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig({
    save: 'Display as avatar',
    cancel: 'Save to inventory',
    hasCustomCancel: true,
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public critter: Critter,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.critterImage = this.critter.avatarImage.signedUrl;
  }

  public submit(): void {
    // TODO: Implement avatar display logic
    this.dialogRef.close(this.critter);
  }
}
